<template>
	<div>
		<div style="padding: 10px; text-align: left">
			<el-form ref="pram" :model="pram" @submit.native.prevent label-width="100px" v-loading="loading">
				<el-row :gutter="20">
					<el-col :span="12">
						<el-form-item
							label="客户姓名"
							prop="customerName"
							:rules="[
								{ required: true, message: '请输入客户姓名', trigger: ['change'] },
								{
									max: 255,
									message: '客户姓名不能超过255个字符',
									trigger: ['change'],
								},
							]">
							<el-input v-model="pram.customerName" placeholder="请输入客户姓名" maxlength="255" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item
							label="联系方式"
							prop="contactInfo"
							:rules="[{ required: true, message: '请输入联系方式', trigger: ['change'] }]">
							<el-input v-model="pram.contactInfo" placeholder="请输入联系方式" maxlength="30" />
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item
							label="需求类型"
							prop="demandType"
							:rules="[{ required: true, message: '请选择需求类型', trigger: ['change'] }]">
							<el-select
								v-model="pram.demandType"
								clearable
								filterable
								placeholder="请选择需求类型"
								style="width: 100%">
								<el-option
									v-for="(item, index) in demandTypeDict"
									:label="item.name"
									:value="item.itemCode"
									:key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item
							label="消费意愿"
							prop="consumptionWillingness"
							:rules="[{ required: true, message: '请选择消费意愿', trigger: ['change'] }]">
							<el-select
								v-model="pram.consumptionWillingness"
								clearable
								filterable
								placeholder="请选择消费意愿"
								style="width: 100%">
								<el-option
									v-for="(item, index) in consumptionWillingnessDict"
									:label="item.name"
									:value="item.itemCode"
									:key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item
							label="线索类型"
							prop="leadType"
							:rules="[{ required: true, message: '请选择线索类型', trigger: ['change'] }]">
							<el-select v-model="pram.leadType" clearable filterable placeholder="请选择线索类型" style="width: 100%">
								<el-option
									v-for="(item, index) in leadTypeDict"
									:label="item.name"
									:value="item.itemCode"
									:key="index"></el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item
							label="跟进人"
							prop="followUpPersonId"
							:rules="[{ required: true, message: '请选择跟进人', trigger: ['change'] }]">
							<el-select
								v-model="pram.followUpPersonId"
								clearable
								filterable
								placeholder="请选择跟进人"
								style="width: 100%">
								<el-option v-for="(item, index) in saleList" :label="item.realName" :value="item.id" :key="index">
									<span>{{ item.realName }}</span>
									<span style="margin-left: 10px; color: #8492a6; font-size: 12px">{{ item.account }}</span>
									<span style="margin-left: 10px; color: #8492a6; font-size: 12px">
										{{ item.rolesNewDesc && item.rolesNewDesc.length ? item.rolesNewDesc : '无身份信息' }}
									</span>
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-popover placement="bottom" title="线索来源" width="550" trigger="click">
							<div class="source-list">
								<el-row :gutter="10">
									<el-col :span="6" v-for="(item, index) in leadSourceDict" :key="index">
										<div
											class="source-item"
											:class="{ 'source-item-active': pram.leadSourceDesc === item.name }"
											@click="selectLeadSource(item)">
											{{ item.name }}
										</div>
									</el-col>
								</el-row>
							</div>
							<el-form-item label="线索来源" prop="leadSource" slot="reference">
								<el-input v-model="pram.leadSourceDesc" placeholder="请选择线索来源" maxlength="20" readonly>
									<el-button slot="append" icon="el-icon-delete" @click.stop="clearLeadSource"></el-button>
								</el-input>
							</el-form-item>
						</el-popover>
					</el-col>

					<el-col :span="12">
						<el-form-item label="下次跟进时间" prop="nextFollowUpTime">
							<el-date-picker
								v-model="pram.nextFollowUpTime"
								type="datetime"
								placeholder="选择日期"
								value-format="yyyy-MM-dd HH:mm:ss"
								style="width: 100%"></el-date-picker>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="行政区划" prop="administrativeDivision">
							<RegionCascader
								v-model="pram.administrativeDivision"
								:options="cityList"
								@handleChange="handleChange"
								clearable
								style="width: 100%"></RegionCascader>
						</el-form-item>
					</el-col>

					<el-col :span="12">
						<el-form-item label="详细地址" prop="detailedAddress">
							<el-input v-model="pram.detailedAddress" placeholder="请输入详细地址" maxlength="100" />
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item label="备注" prop="remarks">
							<el-input v-model="pram.remarks" type="textarea" placeholder="请输入备注" maxlength="200" />
						</el-form-item>
					</el-col>

					<el-col :span="24">
						<el-form-item style="text-align: right">
							<el-button type="primary" @click="handlerSubmit('pram')" style="margin-top: 20px">保 存</el-button>
							<el-button @click="cancelForm">取 消</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
		</div>
	</div>
</template>

<script>
	// import * as clueApi from '@/api/clueNew'
	import citys from '@/utils/city';
	import { getDictionaryByCode } from '@/utils/dict';
	import RegionCascader from '@/components/RegionCascader/index.vue';
	export default {
		components: { RegionCascader },
		props: {
			isCreate: {
				type: Number,
				required: true,
			},
			editData: {
				type: Object,
				default: null,
			},
			demandTypeDict: {
				type: Array,
				required: true,
			},
			consumptionWillingnessDict: {
				type: Array,
				required: true,
			},
			leadTypeDict: {
				type: Array,
				required: true,
			},
			leadSourceDict: {
				type: Array,
				required: true,
			},
		},
		data() {
			return {
				loading: false, // 加载状态
				pram: {
					// 表单数据
					customerName: '',
					contactInfo: '',
					demandType: '',
					consumptionWillingness: '',
					leadType: '',
					leadSource: '',
					leadSourceDesc: '',
					followUpPersonId: '',
					nextFollowUpTime: '',
					administrativeDivision: '',
					detailedAddress: '',
					remarks: '',
				},
				cityList: citys,
				saleList: [], // 跟进人列表
			};
		},
		mounted() {
			this.followUpPerson(); // 获取跟进人列表
			this.initEditData(); // 获取数据
		},
		methods: {
			// 选择线索来源
			selectLeadSource(item) {
				this.pram.leadSource = item.itemCode;
				this.pram.leadSourceDesc = item.name;
				// 关闭popover
				this.$nextTick(() => {
					document.body.click();
				});
			},
			// 清除线索来源
			clearLeadSource() {
				this.pram.leadSource = '';
				this.pram.leadSourceDesc = '';
			},
			// 获取跟进人列表
			async followUpPerson() {
				// await clueApi.adminList().then(data => {
				//   this.saleList = data.list
				// })
			},
			// 获取数据
			async initEditData() {
				if (this.isCreate != 1) return;
				this.loading = true;
				// await clueApi.getClueById({ clueId: this.editData.id }).then(res => {
				//   this.pram = res;
				//   // 设置线索来源名称
				//   if (res.leadSource) {
				//     const foundSource = this.leadSourceDict.find(item => item.itemCode === res.leadSource);
				//     this.pram.leadSourceDesc = foundSource ? foundSource.name : '';
				//   }
				//   this.loading = false
				// }).catch(() => {
				//   this.loading = false
				// })
			},
			// 行政区划选择
			handleChange(value) {
				this.pram.administrativeDivision = value[value.length - 1];
			},
			// 保存
			handlerSubmit(form) {
				this.$refs[form].validate(valid => {
					if (!valid) {
						this.$message.info('必填信息未填全');
						return;
					}
					this.handlerSave();
				});
			},
			// 新增、编辑
			handlerSave() {
				this.loading = true;
				// if (this.isCreate == 1) { //修改
				// clueApi.updateClue(this.pram).then(res => {
				//   this.loading = false
				//   this.$message.success('修改成功');
				//   this.cancelForm();
				// }).catch(() => {
				//   this.cancelForm()
				// })
				// } else { //新增
				//   clueApi.checkClue(this.pram).then(res => {
				//     if (res.flag) {
				//       this.loading = false
				//       this.$confirm('此客户线索已存在，是否再次添加!', '线索重复添加确认', {
				//         confirmButtonText: '确定',
				//         cancelButtonText: '取消',
				//         type: 'warning'
				//       }).then(() => {
				//         clueApi.addClue(this.pram).then(res => {
				//           this.loading = false
				//           this.$message.success('新增成功');
				//           this.cancelForm();
				//         })
				//       })
				//     } else {
				//       clueApi.addClue(this.pram).then(res => {
				//         this.loading = false
				//         this.$message.success('新增成功');
				//         this.cancelForm();
				//       })
				//     }
				//   }).catch(() => {
				//     this.loading = false
				//   })

				// }
			},
			// 取消
			cancelForm() {
				this.$emit('hideDialogCreate');
			},
		},
	};
</script>

<style lang="scss" scoped>
	.source-item {
		padding: 10px;
		margin-bottom: 10px;
		cursor: pointer;
		background-color: #f2f6fa;
		border-radius: 5px;
		transition: all 0.3s;

		&:hover {
			background-color: #e0eaf7;
		}
	}

	.source-item-active {
		background-color: #409eff;
		color: white;
	}

	.el-form-item {
		width: 100%;
	}

	.el-select,
	.el-input {
		width: 100%;
	}

	.el-row {
		display: flex;
		flex-wrap: wrap;
	}

	.el-col {
		flex: 0 0 auto;
	}
</style>
